export default __webpack_public_path__ + "static/media/ipad3.fdd50876.webp";